import { Popover } from '@ets/design-system';
import { ReactNode } from 'react';
import { useSelector } from '_common/hooks';

type ShortcutsPopoverProps = {
  children: ReactNode;
  testId: string;
  offsets: Rect | null;
};

const ShortcutsPopover = ({ children, testId, offsets }: ShortcutsPopoverProps) => {
  const zoom = useSelector((state) => state.editor.status.zoom);

  if (!offsets) {
    return null;
  }

  return (
    <Popover.Root open={true} placement="bottom-start">
      <Popover.Trigger asChild>
        <div
          style={{
            width: offsets.width / zoom,
            height: offsets.height / zoom,
          }}
          className="pointer-events-none absolute z-6"
          data-testid={`${testId}-inline-properties-container`}
        />
      </Popover.Trigger>
      <Popover.Content
        testId={`${testId}-inline-properties`}
        className="fixed! z-1 min-w-auto"
        focusManagerProps={{ initialFocus: -1 }}
      >
        {children}
      </Popover.Content>
    </Popover.Root>
  );
};

export default ShortcutsPopover;
